import React, { useEffect, useContext,  useState } from 'react';
import { toast } from 'react-toastify';
import DefaultCard from '../../../../../../components/default/DefaultCard';
import DefaultToolBar from '../../../../../../components/default/DefaultToolBar';
import ButtonCreate from '../../../../../../components/buttons/ButtonCreate';
import DefaultModal from '../../../../../../components/default/DefaultModal';
import useSweetAlert from '../../../../../../hooks/useSweetAlert';
import { ServiceResponse } from '../../../../../../app/services/shared/interfaces';
import WarehouseQuoteExpeditionCreate from '../WarehouseExpeditionCreate';
import WarehouseQuoteExpeditionEdit from '../WarehouseExpeditionEdit';
import WarehouseQuoteRateDataTable from '../tables/WarehouseQuoteExpeditionDataTable';
import WarehouseQuoteExpeditionDataTable from '../tables/WarehouseQuoteExpeditionDataTable';
import { WarehouseExpeditionDataForm, WarehouseExpeditionShowDataForm, WarehouseQuoteExpeditionFilters } from '../../../../../../app/models/WareHouseQuoteExpedition';
import useWarehouseQuoteExpeditionService from '../../../../../../app/services/hooks/useWareHouseQuoteExpeditionService';
import useReactConfirmAlert from '../../../../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../../../../contexts/AppContext';
import WarehouseQuoteExpeditionShow from '../WarehouseExpeditionShow';

interface Props {
    quoteId: number;
    // expeditions: WarehouseExpeditionDataForm;
    disableUpdate?: boolean;
    refresh?: number;
    isFormShow?: boolean;
}

const WarehouseQuoteExpeditionContainer = ({
    quoteId,
    disableUpdate = false,
    isFormShow = false,
    refresh
}: Props) => {
    const {
        getWarehouseQuoteExpedition,
        getAllWarehouseQuoteExpeditionsByQuote,
        updateWarehouseQuoteExpedition,
        deleteWarehouseQuoteExpedition,
        fetchingGetWarehouseQuoteExpedition,
        fetchingUpdateWarehouseQuoteExpedition
    } = useWarehouseQuoteExpeditionService();

    const [expeditionData, setExpeditionData] = useState<WarehouseExpeditionDataForm>({
        container_type: ''
    });

    const [warehouseQuoteExpedition, setWarehouseQuoteExpedition] = useState<WarehouseExpeditionShowDataForm[]>([]);
    const [warehouseExpeditionIdEdit, setWarehouseExpeditionIdEdit] = useState<number>(-1);
    const [warehouseExpeditionIdCreate, setWarehouseExpeditionIdCreate] = useState<number>(-1);
    const [warehouseExpeditionIdShow, setWarehouseExpeditionIdShow] = useState<number>(-1);
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    
    const [totalRows, setTotalRows] = useState<number>(0);
    const [filter, setFilter] = useState<WarehouseQuoteExpeditionFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'desc'
    });
    const [showingCreate, setShowingCreate] = useState(false);
    const [showingEdit, setShowingEdit] = useState(false);
    const [showingShow, setShowingShow] = useState(false);

    useEffect(() => {
        if (quoteId) reloadTable();
    }, [quoteId, filter,refresh]);

    const reloadTable = () => {
        getAllWarehouseQuoteExpeditionsByQuote(quoteId,filter, {
            onSuccess: (response: ServiceResponse) => {
                setWarehouseQuoteExpedition(response.data.warehouse_quote_expeditions);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        });
    };
    const show =  (id: number) => {
        setShowingShow(true);
        setWarehouseExpeditionIdShow(id);

    };

    const showEdit = (id: number) => {
        setShowingEdit(true);
        setWarehouseExpeditionIdEdit(id);
    };

    const hideEdit = () => {
        setShowingEdit(false);
        setWarehouseExpeditionIdEdit(-1);
    };

    const hideShow = () => {
        setShowingShow(false);
        setWarehouseExpeditionIdShow(-1);
    };

    const hideCreate = () => {
        setShowingCreate(false);
        setWarehouseExpeditionIdCreate(-1);
    };


    const create = () => {
        setShowingCreate(true);
    };

    const update = () => {
        updateWarehouseQuoteExpedition(quoteId, expeditionData, {
            onSuccess: (response: ServiceResponse) => {
                toast.success(response.message);
                setShowingCreate(false);
                setShowingEdit(false);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        });
    };
    const destroy = (id: number) => {
        const message = `Está a punto de eliminar la expediíon #${id}`;

        useReactConfirmAlert().requestConfirmation({
            title: '¿Estás seguro?',
            message: message,
            buttons: {
                confirmButton: {
                    label: 'Sí, eliminar',
                    onClick: () => {
                        if (showLoading)
                            showLoading('loading', 'Eliminando tarifa...');

                        deleteWarehouseQuoteExpedition(id, {
                            onSuccess: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().successAlert({
                                    title: 'Éxito',
                                    message: response.message
                                });

                                reloadTable();
                            },
                            onError: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().errorAlert({
                                    title: 'Error',
                                    message: response.message
                                });
                            }
                        });
                    }
                },
                cancelButton: {
                    label: 'Cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'La tarifa no se ha eliminado.'
                            });
                        }, 0);
                    }
                }
            }
        });
    };


    

    return (
        <>
        <DefaultCard>
            <div className="h3 mt-0 mb-4 card-title">Expedición</div> 
            <div className="row">
                <div className="col-12">
                    {!disableUpdate && (
                        <DefaultToolBar left={<ButtonCreate callbackCreate={() => setShowingCreate(true)} />} />
                    )}
                </div>
                <div className="col-12">
                    <WarehouseQuoteExpeditionDataTable
                        warehouseQuoteExpeditions={warehouseQuoteExpedition}
                        totalRows={totalRows}
                        loading={fetchingGetWarehouseQuoteExpedition}
                        show={show}
                        edit={showEdit}
                        destroy={destroy}
                        filter={filter}
                        setFilter={setFilter}
                        isShow={isFormShow}

                    />
                </div>
            </div>
        </DefaultCard>


            <DefaultModal
                show={showingCreate}
                handleClose={hideCreate}
                title="Crear Expedición"
                showFooter={false}
            >
                <WarehouseQuoteExpeditionCreate
                    quoteId={quoteId}
                    onSaved={() => {
                        reloadTable();
                        setShowingCreate(false);
                    }}
                    onCancel={() => setShowingCreate(false)}
                />
            </DefaultModal>

       {showingEdit ?(
            <DefaultModal
                show={showingEdit}
                handleClose={hideEdit}
                title="Editar Expedición"
                showFooter={false}
            >
                <WarehouseQuoteExpeditionEdit
                    expeditionId={warehouseExpeditionIdEdit}
                    onSaved={() => {
                        reloadTable();
                        setShowingEdit(false);
                    }}
                    onCancel={hideEdit}
                />
            </DefaultModal>
            ) : null}

        {showingShow ? (
            <DefaultModal
                show={showingShow}
                handleClose={hideShow}
                title="Ver información expedicion"

            >
                <WarehouseQuoteExpeditionShow 
                    expeditionId={warehouseExpeditionIdShow} 
                    onCancel={hideShow} 
                />
            </DefaultModal>
            ) : null}


        </>
    );
};

export default WarehouseQuoteExpeditionContainer;
